
export default {
  title: '聯絡我們',
  message: '訊息',
  submit: '送出',
  contact: '聯絡我們',
  contactSuccessTitle: '多謝您的查詢',
  contactSuccessMessage: '我們的客服經理會盡快處理。',
}
